import { gql } from 'apollo-boost';

export const ACCOUNTS_QUERY = gql`{
  self {
    user {
      profiles {
        id
        primary
        role
        mdsEnabled
        ciEnabled
        aiEnabled
        defaultApp {
          app
          landing {
            name
          }
        }
        customer {
          precisionEnabled
          adInsightsEnabled
          name
          apiKey
          tzName
          appEnabled
        }
      }
    }
  }
}`

export const UPDATE_DEFAULT_APP = gql`
  mutation UpdateDefaultApp($profileId: Int!, $payload: DefaultAppInput!) {
    updateDefaultApp(profileId: $profileId, payload: $payload) {
      id,
      defaultApp {
        app
        landing {
          name
        }
      }
    }
  }
`

export const UPDATE_DEFAULT_PROFILE = gql`
  mutation UpdateDefaultProfile($profileId: Int!) {
    updateDefaultProfile(profileId: $profileId) {
      id,
      primary
    }
  }
`
